import React from 'react'
import Table from 'react-bootstrap/Table';


function AdministrativeStaff() {
    return (
        <div>
            <br />
            <div className="container">
                <div className='welcometext'>
                    <h1 className="card-title mb-0"><b>Administrative Staff</b></h1>
                    <div className="col-md-4">
                        <hr style={{ color: "#1D4D93" }} />
                    </div>
                </div>
            </div>
            <div className="album py-1">
                <div className="container">

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>Sl.</th>
                                <th>Name</th>
                                <th>Designation</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>Mr. Subhasis Adhikary	</td>
                                <td>Sr. Office Assistant</td>

                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Mrs. Subhra Mondal Adhikary	</td>
                                <td>Office Assistant</td>

                            </tr>
                            <tr>
                                <td>3</td>
                                <td >Miss Priyanka Chakraborty	</td>
                                <td>Office Assistant</td>

                            </tr>




                           
                        </tbody>
                    </Table>
                </div>
            </div>

        </div>
    )
}

export default AdministrativeStaff